import * as THREE from "three";
import { GroundMesh } from "../groundMesh";
import { Meadow } from "./meadow";

/** A broadleaf crown, for its leaf fall (foliage.ts): the band it sheds from, how wide, autumn-coloured, next leaf in. */
export interface Leafy { lo: number; hi: number; spread: number; autumn: boolean; next: number }
const _leaf = new THREE.Vector3();

/** The trees that drop leaves. */
const SHEDS = /^p_tree_(oak|pair)/;
/** Leaves a gust shakes loose from one crown at once. */
const GUST_LEAVES = 3;

/** The crown a tree sheds leaves from, measured once as it is placed; null for conifers and dead trees. */
export function crownOf(prop: THREE.Object3D, name: string): Leafy | null {
  if (!SHEDS.test(name)) return null;
  prop.updateMatrixWorld(true);
  const box = new THREE.Box3().setFromObject(prop);
  return {
    lo: box.min.y + (box.max.y - box.min.y) * 0.55, hi: box.max.y * 0.97 + box.min.y * 0.03,
    spread: Math.min(0.45, (box.max.x - box.min.x) * 0.35), autumn: /autumn/.test(name), next: Math.random() * 4,
  };
}

/**
 * Falling leaves (Phase 2, the living meadow): each broadleaf crown lets one go every few seconds, and a small flurry
 * when a wind band's crest reaches it — so a gust crossing the map is visible as leaves streaming off the oaks in
 * sequence. Ambient sprites (Meadow.leaf): dropped first when the pool is busy, scaled by tier, off when reduced.
 */
export function dropLeaves(L: Leafy | null, root: THREE.Vector3, dt: number, gusted: boolean): void {
  const fx = Meadow.vfx;
  if (!L || !fx) return;
  const every = Meadow.leafInterval(fx.lod, Meadow.reduced());
  if (!isFinite(every)) return;
  L.next -= dt;
  let n = gusted ? GUST_LEAVES : 0;
  if (L.next <= 0) { n++; L.next = every * (0.6 + Math.random() * 0.8); }
  for (let k = 0; k < n; k++) {
    const a = Math.random() * Math.PI * 2, r = Math.sqrt(Math.random()) * L.spread;
    _leaf.set(root.x + Math.cos(a) * r, L.lo + Math.random() * (L.hi - L.lo), root.z + Math.sin(a) * r);
    if (!Meadow.leaf(_leaf, L.autumn, GroundMesh.WindDir)) break;
  }
}
